// Expenses — recent Purchase transactions with a 30/60/90-day window, and
// under them (Financials v2 slice 1) the bank-feed line: how many bank
// transactions the latest statements show that QuickBooks does not have yet.
// bank_status is read on its own; its error stays in that line.
import React, { useState } from "react";
import { C, font, mono } from "../../../lib/styles.js";
import { useQbo } from "../lib/useQbo.js";
import { bankOverview } from "../lib/bankData.js";
import { BankFeedLine } from "./BankParts.jsx";
import UnmatchedLists from "./UnmatchedLists.jsx";
import {
  ErrorPanel, Loading, RefreshButton, Seg, lblStyle, money, panel, td, tdNum, th,
} from "./common.jsx";

export default function Expenses({ ctx, onGoSettings }) {
  const [days, setDays] = useState(30);
  const { data, loading, error, refresh } = useQbo(ctx, "list_recent_expenses", { days });
  const bank = useQbo(ctx, "bank_status");
  const [feedOpen, setFeedOpen] = useState(false);
  if (error) return <ErrorPanel error={error} onRetry={refresh} />;

  const expenses = data?.expenses ?? [];
  return (
    <div style={{ fontFamily: font }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
        <Seg
          options={[{ label: "30 days", value: 30 }, { label: "60 days", value: 60 }, { label: "90 days", value: 90 }]}
          value={days} onChange={setDays}
        />
        <span style={lblStyle}>
          Total spend · {days}d:{" "}
          <span style={{ color: C.text, fontFamily: mono, fontSize: 13 }}>
            {loading && !data ? "…" : money(data?.totalSpend, false)}
          </span>
          {"  "}<RefreshButton onClick={refresh} />
        </span>
      </div>
      {loading && !data ? <Loading label="Loading expenses…" /> : (
        <div style={{ ...panel, padding: 0, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>Date</th><th style={th}>Payee</th><th style={th}>Account</th>
                <th style={th}>Type</th><th style={{ ...th, textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((e) => (
                <tr key={e.id}>
                  <td style={td}>{e.txnDate ?? "—"}</td>
                  <td style={td}>{e.payee ?? "—"}</td>
                  <td style={td}>{e.account ?? "—"}</td>
                  <td style={td}>{e.paymentType ?? "—"}</td>
                  <td style={tdNum}>{money(e.total)}</td>
                </tr>
              ))}
              {expenses.length === 0 && (
                <tr><td style={{ ...td, color: C.muted, textAlign: "center" }} colSpan={5}>No expenses in this window.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <BankFeedLine
        bank={bank}
        overview={bank.data && !bank.error ? bankOverview(bank.data) : null}
        open={feedOpen}
        onToggle={() => setFeedOpen((o) => !o)}
        onGoSettings={onGoSettings}
        onRetry={bank.refresh}
        renderAccount={(row) => (
          <UnmatchedLists ctx={ctx} accountId={row.accountId} row={row} only="notInBooks" />
        )}
      />
    </div>
  );
}
